import { FC } from "react";
import { v4 as randomId } from "uuid";

import { AppImageUploader, EFileTypes } from "../../../components";

type Props = {
  value?: string | null;
  onChange?: (value?: string) => void;
  label?: string;
};

/** Картинка раздела ТВ: грузится в папку tv хранилища, в форме хранится путь. */
export const TvImageField: FC<Props> = ({
  value,
  onChange,
  label = "Обложка",
}) => (
  <AppImageUploader
    type="TV"
    serviceType={EFileTypes.TV}
    entityId={`${randomId()}`}
    value={value ?? undefined}
    onChange={onChange}
    cropperProps={{ modalTitle: "Редактировать изображение" }}
    uploadProps={{ multiple: false, children: label, listType: "picture-card" }}
  />
);
